import { all, put, takeLatest, call } from 'redux-saga/effects';
import { ArcgisActionTypes } from 'types';
import {
  getArcgisPasswordSuccess,
  getArcgisPasswordFailure,
  addArcgisPasswordSuccess,
  addArcgisPasswordFailure,
  deleteArcgisPasswordSuccess,
  deleteArcgisPasswordFailure
} from './actions';
import {
  getArcgisPassword,
  addArcgisPassword,
  deleteArcgisPassword
} from 'services/arcgis.service';

function* handleGetArcgisPassword() {
  try {
    const response = yield getArcgisPassword();
    if (response.error) {
      return yield put(getArcgisPasswordFailure(response.error.message));
    }
    if (response?.username) {
      yield put(
        getArcgisPasswordSuccess({
          username: response.username
        })
      );
    } else {
      yield put(
        getArcgisPasswordFailure('Unable to get GIS access credentials')
      );
    }
  } catch (err) {
    const errMsg = err?.response?.data?.error?.message || err?.toString();
    yield put(getArcgisPasswordFailure(errMsg));
  }
}

function* handleAddArcgisPassword(request: any) {
  try {
    const response = yield addArcgisPassword(request.payload);
    if (response.error) {
      return yield put(addArcgisPasswordFailure(response.error.message));
    }
    if (response?.username) {
      yield put(
        addArcgisPasswordSuccess({
          username: response.username,
          password: response.password
        })
      );
    } else {
      yield put(
        addArcgisPasswordFailure('Unable to generate GIS access credentials')
      );
    }
  } catch (err) {
    const errMsg = err?.response?.data?.error?.message || err?.toString();
    yield put(addArcgisPasswordFailure(errMsg));
  }
}

function* handleDeleteArcgisPassword() {
  try {
    yield deleteArcgisPassword();
    yield put(deleteArcgisPasswordSuccess());
  } catch (err) {
    const errMsg = err?.response?.data?.error?.message || err?.toString();
    yield put(deleteArcgisPasswordFailure(errMsg));
  }
}

function* watchGetArcgisPassword() {
  yield takeLatest(
    ArcgisActionTypes.GET_ARCGIS_PWD_START,
    handleGetArcgisPassword
  );
}

function* watchAddArcgisPassword() {
  yield takeLatest(
    ArcgisActionTypes.ADD_ARCGIS_PWD_START,
    handleAddArcgisPassword
  );
}

function* watchDeleteArcgisPassword() {
  yield takeLatest(
    ArcgisActionTypes.DELETE_ARCGIS_PWD_START,
    handleDeleteArcgisPassword
  );
}

function* ArcgisSagas() {
  yield all([
    call(watchGetArcgisPassword),
    call(watchAddArcgisPassword),
    call(watchDeleteArcgisPassword)
  ]);
}

export default ArcgisSagas;
